import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import { Countrydream } from "@/Action/apirouts";
import { API_URL } from "@/Constant";

const Nav = () => {
  const [activeMenuItem, setActiveMenuItem] = useState(null);
  const [isClient, setIsClient] = useState(false);
  const [countriesdata, setCountriesdata] = useState([]);
  const router = useRouter();
  const CountryDreamDatashow = async () => {
    const fullUrl = `${API_URL}${Countrydream}`; // Construct full URL with query parameters
    try {
      // Attempt to fetch using the Fetch API
      const fetchResponse = await fetch(fullUrl, {
        headers: { "Content-Type": "application/json" },
      });

      if (!fetchResponse.ok) {
        throw new Error(`Fetch error: ${fetchResponse.statusText}`);
      }

      const fetchData = await fetchResponse.json();
      setCountriesdata(fetchData.data.countries);
      return { res: fetchData };
    } catch (fetchError) {
      console.error("Fetch failed. Falling back to Axios.", fetchError);
      // Fall back to Axios if Fetch fails
      try {
        const axiosResponse = await axios.get(url, {
          params: data,
          headers: { "Content-Type": "application/json" },
        });

        if (axiosResponse.status === 200) {
          return { res: axiosResponse.data };
        }

        return axiosResponse.data;
      } catch (axiosError) {
        console.error("Axios also failed.", axiosError);

        if (axiosError.response) {
          throw axiosError.response.data;
        }
        throw axiosError.message;
      }
    }
  };

  useEffect(() => {
    setIsClient(true);
    CountryDreamDatashow();
  }, []);

  const isActive = (href) => router.pathname.startsWith(href);

  const toggleMenuItem = (item) => {
    setActiveMenuItem(activeMenuItem === item ? null : item);
  };

  if (!isClient) {
    return null; // Prevent server-side render mismatch
  }

  return (
    <nav className="mainmenu-nav">
      <ul className="mainmenu">
        <li className="with-megamenu  position-static">
          <Link
            className={`${activeMenuItem === "home" ? "open" : ""}`}
            onClick={() => toggleMenuItem("home")}
            href="/"
          >
            Home
          </Link>
        </li>

        <li className="with-megamenu  position-static">
          <Link
            className={`${activeMenuItem === "about" ? "open" : ""}`}
            onClick={() => toggleMenuItem("about")}
            href="/about"
          >
            About Us
          </Link>
        </li>

        <li
          className={`has-dropdown ${
            countriesdata?.length > 0 && "has-menu-child-item"
          } `}
        >
          <Link
            className={`${activeMenuItem === "courses" ? "open" : ""}`}
            href="#"
            onClick={() => toggleMenuItem("courses")}
          >
            Study Destinations
            <i className="feather-chevron-down"></i>
          </Link>

          <div
            className={`submenu ${
              activeMenuItem === "courses" ? "active d-block" : ""
            }`}
          >
            <div className="wrapper">
              {countriesdata &&
                countriesdata.map((data, index) => {
                  return (
                    <li className="" key={index}>
                      <Link href={`/${data.slug}`}>
                        {" "}
                        Study in {data.countryName}
                      </Link>
                    </li>
                  );
                })}
            </div>
          </div>
        </li>

        <li className="">
          <Link
            className={`${activeMenuItem === "dashboard" ? "open" : ""}`}
            href="/universitycollege"
            onClick={() => toggleMenuItem("dashboard")}
          >
            University & Colleges
          </Link>
        </li>

        <li className="with-megamenu position-static">
          <Link
            href="/study-courses"
            className={`${activeMenuItem === "pages" ? "open" : ""}`}
            onClick={() => toggleMenuItem("pages")}
          >
            Study Courses
          </Link>
        </li>

        <li className="with-megamenu  position-static">
          <Link
            href="/events"
            className={`${activeMenuItem === "elements" ? "open" : ""}`}
            onClick={() => toggleMenuItem("elements")}
          >
            Events
          </Link>
        </li>
        <li className="with-megamenu  position-static">
          <Link
            href="/blog"
            className={`${activeMenuItem === "elements" ? "open" : ""}`}
            onClick={() => toggleMenuItem("elements")}
          >
            Blogs
          </Link>
        </li>
        <li className="with-megamenu  position-static">
          <Link
            href="/elements/gallery"
            className={`${activeMenuItem === "gallery" ? "open" : ""}`}
            onClick={() => toggleMenuItem("gallery")}
          >
            Gallery
          </Link>
        </li>
        <li className="with-megamenu  position-static">
          <Link
            href="/vouchers"
            className={`${activeMenuItem === "vouchers" ? "open" : ""}`}
            onClick={() => toggleMenuItem("vouchers")}
          >
            Vouchers
          </Link>
        </li>
        {/* <li className="access-icon">
          <Link className="search-trigger-active " href="#">
            <span className="feather-search"></span>
          </Link>
        </li> */}

        <li className="with-megamenu has-menu-child-item position-static d-flex align-items-center">
          <div className="rbt-btn-wrapper ">
            <Link
              className="rbt-btn btn-border-gradient radius-round btn-sm hover-transform-none justify-content-center text-center"
              style={{
                width: "133px",
                padding: "0px",
              }}
              href="/contact-us"
            >
              <span>Contact Us</span>
            </Link>
          </div>{" "}
        </li>
      </ul>
    </nav>
  );
};

export default Nav;
